import { new__cn as cn, createTwStyle } from '../util';
import type { VGridProps } from './type';

const twStyle = createTwStyle<VGridProps>();

export default twStyle({
  container: () => [
    cn('grid', 'gap-(--gap)', 'grid-cols-(--columns)', 'grid-rows-(--rows)'),
  ],
});
